var initPjs = function initPjs(engine) {
  var particlesJS = function particlesJS(tagId, options) {
    return engine.load(tagId, options);
  };
  particlesJS.load = function (tagId, pathConfigJson, callback) {
    engine.loadJSON(tagId, pathConfigJson).then(function (container) {
      if (container) {
        callback(container);
      }
    }).catch(function () {
      callback(undefined);
    });
  };
  particlesJS.setOnClickHandler = function (callback) {
    engine.setOnClickHandler(callback);
  };
  var pJSDom = engine.dom();
  return {
    particlesJS: particlesJS,
    pJSDom: pJSDom
  };
};
export { initPjs };